import OfferTilePricing from 'components/OfferList/OfferListTiles/Support/OfferTilePricing'
import { isCruiseOnlyOfferView, type CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruisePriceByNight from 'hooks/useCruisePriceByNight'
import CruiseSearchTilePricing from './CruiseSearchTilePricing'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import { getCheapestCruiseFlashOfferByCabin } from 'lib/cruises/getCheapestCruiseFlashOfferByCabin'
import { hasDisplayablePackagePrice, isDisplayablePrice } from 'lib/offer/pricingVisibility'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePriceStack({ view }: Props) {
  const isPricePerNight = useCruisePriceByNight()
  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  if (!isCruiseOnlyOfferView(view)) {
    const cheapestPackage = getCheapestCruiseFlashOfferByCabin({ offer: view.offer, cabinType: selectedCabinType || '' })
    const pricingPackage = cheapestPackage || view.offer.lowestPricePackage

    if (!hasDisplayablePackagePrice(pricingPackage)) return null

    return <OfferTilePricing
      offer={view.offer}
      isPricePerNight={isPricePerNight}
      pkg={pricingPackage}
    />
  }

  if (!isDisplayablePrice(view.lowestPrice?.primaryPrice.total)) return null

  return <CruiseSearchTilePricing view={view} />
}

export default CruiseSearchTilePriceStack
